import { EditorProvider } from '@tiptap/react';


import StarterKit from '@tiptap/starter-kit';

interface TiptapProps {
  editorContent: string;
  setEditorContent: (content: string) => void;
  className?: string; // Optional prop for Tailwind classes
}

// Define your extension array
const extensions = [StarterKit];

const Tiptap = ({ editorContent, setEditorContent, className }: TiptapProps) => {
  return (
    <EditorProvider
      extensions={extensions}
      content={editorContent}
      onUpdate={({ editor }) => {
        const plainText = editor.getText(); 
        setEditorContent(plainText); 
      }}
      editorProps={{
        attributes: {
          class: className || '', 
        },
      }}
    >
      {/* Editor content goes here */}
    </EditorProvider>
  );
};

export default Tiptap;

